(function() {
  'use strict';

  angular.module('eclipseApp.checkout').directive('createProfileSummaryHolder', [
    'uteLocale',
    '$rootScope',
    function(uteLocale, $rootScope) {
      return {
        restrict: 'E',
        replace: true,
        link: function(scope, elem, attr, ctrl) {
          scope.language = uteLocale.language;
          scope.loggedIn = $rootScope.ruiMethods.user.is.loggedIn();
        },
        templateUrl: 'modules/checkout/create-profile-summary/create-profile-summary-holder.directive.html'
      };
    }
  ]);
})();
